import { render } from "./Carga.vue?vue&type=template&id=11d784fb&scoped=true"
import script from "./Carga.vue?vue&type=script&lang=js"
export * from "./Carga.vue?vue&type=script&lang=js"

import "./Carga.vue?vue&type=style&index=0&id=11d784fb&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d784fb"]])

export default __exports__